import _curry2 from "./_curry2.js";
import _xfBase from "./_xfBase.js";
var XTap = /*#__PURE__*/
function () {
  function XTap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTap.prototype['@@transducer/init'] = _xfBase.init;
  XTap.prototype['@@transducer/result'] = _xfBase.result;
  XTap.prototype['@@transducer/step'] = function (result, input) {
    this.f(input);
    return this.xf['@@transducer/step'](result, input);
  };
  return XTap;
}();
var _xtap = /*#__PURE__*/
_curry2(function _xtap(f, xf) {
  return new XTap(f, xf);
});
export default _xtap;